/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chevron_left = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 3 5 8l5 5"
    />
  </svg>
)
export default chevron_left
